import { type MouseEvent, useCallback, useState } from 'react'

import { useLinkInternal } from '@/hooks/useLinkInternal'
import { fetchRandom } from '@/utils/apiUtil'
import { isModifiedClick } from '@/utils/commonUtil'

export const useRandomLink = () => {
  const { redirectUrl } = useLinkInternal()
  const [loading, setLoading] = useState(false)

  const redirectRandom = useCallback(async () => {
    setLoading(true)
    const path = await fetchRandom()
    redirectUrl(path || '/')
    setLoading(false)
  }, [redirectUrl])

  const onClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      if (isModifiedClick(e)) return

      e.preventDefault()
      if (!loading) void redirectRandom()
    },
    [loading, redirectRandom],
  )

  return { loading, onClick, redirectRandom }
}
